module.exports = __webpack_public_path__ + "img/class1.1dda21e8.png";